import { IRenderingCommonContext, IRenderingContextData } from "../types/rendering/rendering-common-context";

export class RenderingCommonContextUtil {

    public static getRenderingCommonContext(doc: Document): IRenderingCommonContext {
        const value = doc.documentElement.getAttribute("data-rendering-info")!;

        return {
            renderedDoc: doc,
            data: JSON.parse(value) as IRenderingContextData
        };
    }

}